module.exports = " /*\n   * BiwaScheme 0.6.4.dev - R6RS Scheme in JavaScript\n   *\n   * Copyright (c) 2007-2012 Yutaka HARA (http://www.biwascheme.org/)\n   * Licensed under the MIT license.\n   */\n  \n  var BiwaScheme = BiwaScheme || {};\n  \n  BiwaScheme.Version = \"0.6.4.dev\";\n  BiwaScheme.VERSION = \"0.6.4.dev\";\n  BiwaScheme.GitCommit = \"208de844814ade584aa72429ea375ec9ec349d7b\";"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./node_modules/biwascheme/src/version.js
// module id = 29
// module chunks = 0